module.exports = __webpack_public_path__ + "static/media/lines_1.72479335.svg";